import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { WchService } from '../wch.service';
import { opAssertInAngularZone } from '../zone/zone.service';
import { RenderingContext, RenderingContextQueryResult, SitePagesQueryResult, WchSdkSearch } from './../../../api';
import { queryToString } from './../../../utils';
import { li } from './../../services/logger/logger.service';
import { QueryInput } from './../../utils/url.utils.ifaces';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'SearchService';

@Injectable({ providedIn: 'root' })
export class SearchService implements WchSdkSearch {
  // the API
  getRenderingContextById: (
    aId: string,
    aLevels?: number
  ) => Observable<RenderingContext>;
  getRenderingContexts: (
    aValue: QueryInput,
    aLevels?: number
  ) => Observable<RenderingContextQueryResult>;
  getSitePages: (aValue: QueryInput) => Observable<SitePagesQueryResult>;

  constructor(wchService: WchService) {
    // instance
    const that = this;

    // the API
    function _getRenderingContextById(
      aId: string,
      aLevels?: number
    ): Observable<RenderingContext> {
      // log this
      li(LOGGER, 'getRenderingContextById', aId, aLevels);
      // dispatch
      return wchService.getRenderingContextById(aId, aLevels);
    }

    function _getRenderingContexts(
      aValue: QueryInput,
      aLevels?: number
    ): Observable<RenderingContextQueryResult> {
      // convert the value to a string
      const query = queryToString(aValue);
      // log this
      li(LOGGER, 'getRenderingContexts', query, aLevels);
      // dispatch
      return wchService.getRenderingContextsByQuery(query, aLevels);
    }

    function _getSitePages(
      aValue: QueryInput
    ): Observable<SitePagesQueryResult> {
      // convert the value to a string
      const query = queryToString(aValue);
      // log this
      li(LOGGER, 'getSitePages', query);
      // dispatch
      return wchService.getSitePagesByQuery(query).pipe(
        // just a quick sanity check
        opAssertInAngularZone()
      );
    }

    // assign
    that.getRenderingContextById = _getRenderingContextById;
    that.getRenderingContexts = _getRenderingContexts;
    that.getSitePages = _getSitePages;
  }
}
